import React from 'react'
import {Link} from 'react-router-dom'
import {RequisitoAlistamiento} from '../../../interfaces/normativa.interface'

interface CaminoRequisito {
  texto: string
  ruta: string
  etiqueta: string
}

const CAMINOS_REQUISITO: Record<string, CaminoRequisito> = {
  SERIES: {
    texto:
      'Revise la serie de cada documento en cada uno de sus establecimientos y actualícela al formato que exige la versión 2.',
    ruta: '/gestion-usuarios/estado-documentos',
    etiqueta: 'Ir al estado de documentos',
  },
  ESTABLECIMIENTO: {
    texto:
      'Revise los datos de cada establecimiento y complete el tipo de establecimiento y el punto de venta que la versión 2 exige.',
    ruta: '/gestion-usuarios/estado-documentos',
    etiqueta: 'Ir al estado de documentos',
  },
  DISTRITO_SUCURSAL: {
    texto: 'Revise la dirección de cada establecimiento e indique el distrito que le corresponde.',
    ruta: '/gestion-usuarios/estado-documentos',
    etiqueta: 'Ir al estado de documentos',
  },
  DISTRITO_CLIENTE: {
    texto:
      'Actualice la dirección de los clientes que ya tiene registrados para que indique el distrito que les corresponde. En la lista de clientes, la columna «Verificación de datos» le señala uno por uno a los que les falta el dato, y puede dejar marcados solo esos. Esto no le impide pasar a la versión 2: el distrito que falte se le pedirá al momento de emitirle a ese cliente y queda guardado en su ficha.',
    ruta: '/gestion-clientes/listar-clientes',
    etiqueta: 'Ir a la lista de clientes',
  },
}

interface PropsListaRequisitos {
  requisitos: Array<RequisitoAlistamiento>
}

const ListaRequisitos = ({requisitos}: PropsListaRequisitos) => {
  if (!requisitos || requisitos.length === 0)
    return (
      <p className='normativa-texto m'>
        No se recibieron requisitos de alistamiento. Vuelva a intentarlo más tarde o comuníquese con
        el equipo de soporte.
      </p>
    )

  return (
    <ul className='normativa-lista'>
      {requisitos.map((requisito) => {
        const camino = CAMINOS_REQUISITO[`${requisito.codigo ?? ''}`.toUpperCase()]
        return (
          <li
            key={requisito.codigo}
            className={`normativa-requisito ${requisito.cumple ? 'cumple' : 'pendiente'}`}
          >
            <div className='normativa-requisito-encabezado'>
              <span className='normativa-requisito-nombre m'>{requisito.nombre}</span>
              <span
                className={`normativa-estado ${
                  requisito.cumple ? 'normativa-estado-cumple' : 'normativa-estado-pendiente'
                }`}
              >
                {requisito.cumple ? 'Cumple' : 'Pendiente'}
              </span>
            </div>
            <p className='normativa-texto m'>{requisito.detalle}</p>
            {!requisito.cumple && camino && (
              <div className='normativa-camino'>
                <p className='normativa-texto m'>{camino.texto}</p>
                <Link
                  to={camino.ruta}
                  className='m button transparent w-inline-block normativa-boton-corto'
                >
                  <div>{camino.etiqueta}</div>
                </Link>
              </div>
            )}
            {!requisito.cumple && !camino && (
              <div className='normativa-camino'>
                <p className='normativa-texto m'>
                  Si no logra resolver este requisito por su cuenta, comuníquese con el equipo de
                  soporte para que le indiquen el camino.
                </p>
              </div>
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default ListaRequisitos
